// Web Push subscribe helper.
import api from '../services/api';

// VAPID public key (base64) → Uint8Array — push API'sinin istediği format
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function supportsPush() {
  return ('serviceWorker' in navigator) && ('PushManager' in window) && ('Notification' in window);
}

export function getPermissionStatus() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}

let cachedPublicKey = null;
async function getVapidPublicKey() {
  if (cachedPublicKey) return cachedPublicKey;
  try {
    const r = await api.get('/push/vapid-public-key');
    if (r.data?.success && r.data.data?.configured) {
      cachedPublicKey = r.data.data.publicKey;
      return cachedPublicKey;
    }
  } catch (e) {}
  return null;
}

export async function subscribeToPush() {
  if (!supportsPush()) return { ok: false, reason: 'unsupported' };
  const reg = await navigator.serviceWorker.ready;
  if (!reg) return { ok: false, reason: 'no-sw' };

  const perm = await Notification.requestPermission();
  if (perm !== 'granted') return { ok: false, reason: 'denied' };

  const publicKey = await getVapidPublicKey();
  if (!publicKey) return { ok: false, reason: 'no-vapid' };

  try {
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }
    // Backend'e kayıt
    const json = sub.toJSON();
    await api.post('/push/subscribe', {
      endpoint: json.endpoint,
      keys: json.keys,
    });
    return { ok: true, subscription: sub };
  } catch (err) {
    return { ok: false, reason: 'subscribe-error', message: err.message };
  }
}

export async function unsubscribeFromPush() {
  if (!supportsPush()) return { ok: false };
  const reg = await navigator.serviceWorker.ready;
  if (!reg) return { ok: false };
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return { ok: true, alreadyOff: true };
  try {
    const endpoint = sub.endpoint;
    await sub.unsubscribe();
    await api.delete('/push/subscribe', { data: { endpoint } });
    return { ok: true };
  } catch (err) {
    return { ok: false, message: err.message };
  }
}

export async function isPushSubscribed() {
  if (!supportsPush()) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch { return false; }
}

export async function sendTestPush() {
  return api.post('/push/test').then(r => r.data);
}
